<template>
  <div>
    <BliModal
      v-if="showTenantSelectionModal"
      mobile-fullscreen
      :active="showTenantSelectionModal"
      class="tenant-picker"
      @blur="handleCloseModal"
    >
      <BliModalHeader @close="handleCloseModal">
        <template #title>
          {{ $t('tenantPicker.selectTenant') }}
        </template>
      </BliModalHeader>
      <BliModalBody>
        <section class="tenant-picker-container">
          <div
            v-if="isFromLoginPage"
            class="tenant-picker-container__title"
          >
            {{ $t('tenantPicker.chooseTenant') }}
          </div>
          <TenantCard
            v-for="(tenantInfo, index) in tenantList"
            :key="index"
            :tenant-info="tenantInfo"
            :selected-tenant="selectedTenant"
            @onTenantSelect="handleTenantSelect"
          />
        </section>
      </BliModalBody>
      <BliModalFooter class="tenant-picker__footer">
        <BliDropdown
          v-model:active="isDropdownActive"
          :disabled="disableSwitchDropdown"
          :header="{
            keepAlive: false
          }"
        >
          <template #tray-header-title>
            {{ $t('tenantPicker.yourAccount') }}
          </template>
          <template #trigger>
            <BliDropdownTrigger
              v-model="selectedCompanyName"
              :label="dropdownLabel"
            />
          </template>
          <template #tray>
            <BliLists
              v-model="selectedCompany"
              mandatory
            >
              <BliList
                v-for="company in companyInfoList"
                :key="company?.companyId"
                :value="company?.companyId || ''"
                @listClick="handleCompanySelect(company?.companyName || '')"
              >
                <template #item-leading>
                  <img
                    src="@vue3/assets/images/company-icon.png"
                    alt="ikon"
                    class="company-icon"
                  >
                </template>
                <section class="company-info">
                  <div>{{ company?.companyName || '' }}</div>
                  <div
                    v-if="company.companyCategory!=='PARENT'"
                    class="label"
                  >
                    {{ company?.nickname || '' }}
                  </div>
                </section>
                <template
                  v-if="company.companyCategory==='PARENT'"
                  #item-trailing
                >
                  <BliBadge
                    color="blue"
                    prominence="tertiary"
                  >
                    {{ $t('appHeader.parent') }}
                  </BliBadge>
                </template>
                <template
                  v-else
                  #item-trailing
                >
                  <BliIconSiEdit @click.native="(event) => handleNickNameEdit(event, company?.companyId)" />
                </template>
              </BliList>
            </BliLists>
          </template>
        </BliDropdown>
        <div class="desc">
          {{ $t('tenantPicker.tenantNote') }}
        </div>
        <BliButton
          :disabled="!selectedTenant"
          :loading="isCompanySwitchInprogress"
          @click="handleSwitchCompany"
        >
          {{ isFromLoginPage ? $t('tenantPicker.proceed') : $t('tenantPicker.select') }}
        </BliButton>
      </BliModalFooter>
    </BliModal>
    <SemanticModal
      v-if="isLogoutModalVisible"
      :show-modal="isLogoutModalVisible"
      :title="$t('tenantPicker.logoutModal.title') "
      :description="$t('tenantPicker.logoutModal.description')"
      :tertiary-button-label="$t('tenantPicker.logoutModal.cancel')"
      :primary-button-label="$t('tenantPicker.logoutModal.logout')"
      :is-long-action="false"
      :size="'small'"
      @closeModal="toggleLogoutConfimation"
      @onTertiaryClick="toggleLogoutConfimation"
      @onPrimaryClick="handleLogout"
    />
    <BliModal
      v-if="showNickNameEditModal"
      :active="showNickNameEditModal"
      width="small"
      @blur="closeNickNameEditModal"
    >
      <BliModalHeader @close="closeNickNameEditModal">
        <template #title>
          {{ $t('tenantPicker.nickName.shopLabel') }}
        </template>
      </BliModalHeader>
      <BliModalBody>
        <section class="nick-name-wrapper">
          <div>{{ $t('tenantPicker.nickName.nickNameDesc') }}</div>
          <BliField
            counter
            :label="$t('tenantPicker.nickName.label')"
            @clear="onClearNickName"
          >
            <BliTextField
              v-model="nickName"
              :max-length="40"
              @keypress="preventSpecialCharacters"
              @paste="handleInputOnPaste"
              @blur="trimSpace"
            />
          </BliField>
        </section>
      </BliModalBody>
      <BliModalFooter>
        <BliButton
          prominence="primary"
          color="common"
          full-width
          :disabled="disableSaveNickName"
          :loading="isUpdatingNickname"
          @click="onSaveNickName"
        >
          {{ $t('common.save') }}
        </BliButton>
      </BliModalFooter>
    </BliModal>
  </div>
</template>
<script src="./index.js" />
<style lang="scss" scoped>
@import "@vue3/assets/styles/custom.scss";
@import "@vue3/assets/styles/_responsive.scss";
html:not([dark]) {
  @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
  @import './index.scss';
}

html[dark] {
  @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
  @import './index.scss';
}
</style>
